"use client";

import { Mail, Package, Search, Watch } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TestingProcess() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: stepsRef,
    isVisible: stepsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const steps = [{
    number: "01.",
    title: "Initial Consultation",
    description: "Contact our team to discuss your environmental concerns. We document your specific situation and schedule a rapid, professional site assessment for your property.",
    Icon: Mail
  }, {
    number: "02.",
    title: "On-Site Sampling",
    description: "Our certified technicians arrive to perform precise air and surface sampling. We utilize clinical-grade equipment to capture accurate data from your indoor environment.",
    Icon: Package
  }, {
    number: "03.",
    title: "Laboratory Analysis",
    description: "Samples are processed in our accredited laboratory. We analyze the data to identify mold species and spore counts, ensuring evidence-based results for your peace of mind.",
    Icon: Search
  }, {
    number: "04.",
    title: "Clinical Report",
    description: "Receive a comprehensive, easy-to-understand report detailing our findings. We provide actionable recommendations to restore your indoor air quality and safety.",
    Icon: Watch
  }];
  return <section data-section-id="3988" id="our-clinical-testing-process" className="bg-background text-foreground py-32 md:py-[200px] px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`text-center mb-24 md:mb-32 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs md:text-sm tracking-[0.3em] mb-8 text-primary">
            THE CLINICAL PROTOCOL
          </p>
          <h2 className="font-default font-bold text-foreground text-4xl md:text-5xl lg:text-6xl xl:text-[64px] leading-[1.1]">
            Our evidence-forward
            <br />
            testing process.
          </h2>
        </div>

        {}
        <div ref={stepsRef} className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-0">
          {}
          <div className="hidden lg:flex absolute top-[88px] left-[12.5%] right-[12.5%] items-center justify-between pointer-events-none z-0">
            {Array.from({
            length: 40
          }).map((_, i) => <span key={i} data-index={i} className={`h-[3px] w-[3px] rounded-lg transition-all duration-700 ease-out ${stepsVisible ? "opacity-100 scale-100" : "opacity-0 scale-0"}`} style={{
            backgroundColor: "var(--primary)",
            transitionDelay: `${i * 40}ms`
          }} />)}
          </div>

          {steps.map((step, i) => {
          const Icon = step.Icon;
          return <div key={i} data-index={i} className={`relative px-0 lg:px-8 transition-all duration-1000 ease-out ${stepsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                {i > 0 && <div className="hidden lg:block absolute left-0 top-0 bottom-0 w-px bg-border" />}

                {}
                <div className="mb-8 flex items-center">
                  <Icon className="w-6 h-6 text-primary" strokeWidth={2} />
                </div>

                {}
                <div className="font-mono font-bold leading-none mb-6 relative z-10 text-primary" style={{
              fontSize: "72px"
            }}>
                  {step.number}
                </div>

                {}
                <div className="h-px mb-8 bg-primary" style={{
              width: "60px"
            }} />

                {}
                <h3 className="font-default font-semibold text-2xl md:text-[28px] text-foreground mb-6 leading-tight">
                  {step.title}
                </h3>

                {}
                <p className="text-[15px] leading-relaxed font-default text-muted-foreground">
                  {step.description}
                </p>
              </div>;
        })}
        </div>

        {}
        <div ref={ctaRef} className={`mt-24 md:mt-[120px] text-center transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Button asChild className="font-mono bg-primary text-white hover:bg-primary/90 tracking-[0.25em] text-sm md:text-base px-8 py-6 rounded-lg shadow-md">
            <Link to="/ContactPage">
              SCHEDULE YOUR INSPECTION &rarr;
            </Link>
          </Button>
          <p className="font-mono text-xs tracking-[0.2em] mt-8 text-muted-foreground">
            OR CALL OUR CLINIC &middot; (561) 560-MOLD (6653)
          </p>
        </div>
      </div>
    </section>;
}